<template>
  <MqResponsive target="xs-md">
    <div class="block text-center" style="width: 100%; margin-top: 60px">
      <el-carousel
        height="auto"
        autoplay
        style="width: 100%"
        indicator-position="none"
      >
        <el-carousel-item style="min-height: 113px; width: 100%">
          <img
            src="@/assets/chaojiao/banner1.jpg"
            alt=""
            class="banner-image"
            style="width: 100%"
          />
        </el-carousel-item>
      </el-carousel>
      <!--  -->
      <div style="min-width: 412px; color: #fff; margin-top: 20px">
        <div>
          <div style="font-size: 30px">精选文章</div>
          <span style="font-size: 12px">SEILECTED ARTICLES</span>
          <div class="line"></div>
        </div>
        <el-row
          :gutter="20"
          style="
            display: flex;
            justify-content: space-around;
            width: 100%;
            margin: 0;
          "
        >
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!-- 交易学院 -->
      <div style="min-width: 412px; color: #fff; margin-top: 20px">
        <div>
          <div style="font-size: 30px">交易学院</div>
          <span style="font-size: 12px">EXCHANGE SCHOOL</span>
          <div class="line"></div>
        </div>

        <el-row :gutter="10" style="margin-bottom: 20px">
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  基础知识
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                交易术语、流程等
              </div>
            </div>

            <img
              src="@/assets/技术分析.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
              margin: 0 0;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  技术分析
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                指标、图表形态讲解
              </div>
            </div>

            <img
              src="@/assets/基础知识.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 0px">
                  基本面分析
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                鷓玘蘺仞Ç喂济数据、政治事件影响
              </div>
            </div>

            <img
              src="@/assets/基础知识.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  交易策略
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                不同风格和风险偏好的策略分享
              </div>
            </div>

            <img
              src="@/assets/即时交易策略.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
              margin: 0 0;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  视频教学
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                实战演示和讲解
              </div>
            </div>

            <img
              src="@/assets/视频教学.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div text-align:center>期待更多...</div>
          </el-col>
        </el-row>
      </div>
      <!-- 交易大赛 -->
      <div
        style="
          min-width: 412px;
          color: #fff;
          margin-top: 20px;
          box-sizing: border-box;
        "
      >
        <div>
          <div style="font-size: 30px">精选文章</div>
          <span style="font-size: 12px">INTRODUCE</span>
          <div class="line"></div>
        </div>
        <el-row
          style="display: flex; flex-direction: column; align-items: center"
        >
          <el-col
            ><div class="grid-content ep-bg-purple" />
            <img style="width: 100%" src="@/assets/16.jpg" alt="Element logo" />
          </el-col>
          <el-col
            style="
              padding: 0 5px;
              text-align: left;
              background: #0f0f0f;
              line-height: 25px;
              height: auto;
              font-size: 12px;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
            ><div class="grid-content ep-bg-purple-light" />

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
            </p>
            <el-button
              type="danger"
              size="large"
              style="
                padding: 12px 55px;
                background: #ce0203;
                border: #ce0203;
                width: 60%;
              "
              >查看详情 »</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!--  -->

      <div
        style="background: #0f0f0f; margin-top: 20px"
        v-for="(item, index) in 2"
        key="index"
      >
        <el-row
          style="
            text-align: left;
            background: #0f0f0f;
            line-height: 25px;
            display: flex;
            align-items: center;
            min-width: 412px;
            padding: 0 10px;
          "
        >
          <el-col :span="5"
            ><div class="grid-content ep-bg-purple" />
            <img
              style="width: 100%"
              src="@/assets/奖杯.png"
              alt="Element logo"
            />
          </el-col>
          <el-col
            style="
              text-align: left;
              line-height: 25px;
              color: #fff;
              font-size: 12px;
              width: 100%;
            "
          >
            <div style="display: flex; align-items: center">
              <div style="font-size: 18px">自由挑战赛(实盘)</div>
              <span
                style="
                  border: 1px solid #d10005;
                  color: #d10005;
                  font-size: 10px;
                  line-height: 16px;
                "
              >
                进行中
              </span>
            </div>
            <div
              style="border-bottom: 1px #4f4f4f solid; width: 100%; height: 1px"
            ></div>
            <p>
              比赛简介:自由实盘挑战赛由冠融科技主办，多家经纪商协办，比赛目的是通过实盘挑战赛方式为操盘手提供展示技术实力和学习
            </p>
            <p>
              周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
            </p>
            <p>
              周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
            </p>
            <div
              style="
                float: right;
                display: flex;
                align-items: center;
                margin-top: 30px;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span style="font-size: 40px">633</span>
                <div>报名人数</div>
              </div>
              <el-button
                type="danger"
                size="large"
                style="
                  background: #ce0203;
                  border: #ce0203;
                  --el-button-size: 23px;
                  font-size: 12px;
                  margin-left: 10px;
                "
                >立即报名 »</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </MqResponsive>
  <!-- 以上手机端 -->
  <div
    style="
      height: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    "
  >
    <MqResponsive target="md+">
      <div class="block text-center" style="height: 500px; width: 100%">
        <el-carousel height="auto" autoplay>
          <el-carousel-item style="height: 500px; overflow: hidden">
            <img
              src="@/assets/chaojiao/主营业务.png"
              alt=""
              class="banner-image"
              style="width: 100%; height: 500px"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
    </MqResponsive>

    <div
      style="
        width: 100%;
        display: flex;
        height: 360px;
        background: #213485;
        color: #fff;
        justify-content: space-around;
        align-items: center;
        padding: 0 50px 0 100px;
        box-sizing: border-box;
      "
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          text-align: left;
          line-height: 1.8;
        "
      >
        <span>CONTACT US</span>
        <span>{{ $t("联系我们") }}</span>
        <span>{{ $t("广州超交市场咨询服务有限公司") }}</span>
        <span>{{ $t("联系人") }}:李定潮</span>
        <span>{{ $t("手机") }}:18310090624</span>
        <span>{{ $t("邮箱") }}:617935071@q9.com</span>
        <span>{{ $t("地址") }}:广州市白云区石井街石潭路132号三层D5049</span>
      </div>

      <div style="display: flex">
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 240px;
            font-size: 18px;
            justify-content: space-around;
          "
        >
          <span>李定潮</span>
          <img src="@/assets/chaojiao/了解更多.jpg" style="width: 60%" />
          <span>{{ $t("电话") }}:18310090624</span>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 240px;
            font-size: 18px;
            color: #fff;
            justify-content: space-around;
          "
        >
          <span>客服晓云</span>
          <img src="@/assets/chaojiao/了解更多.jpg" style="width: 60%" />
          <span>{{ $t("电话") }}:15677134167</span>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 240px;
            font-size: 18px;
            color: #fff;
            justify-content: space-around;
          "
        >
          <span>甘翠静</span>
          <img src="@/assets/chaojiao/了解更多.jpg" style="width: 60%" />
          <span>{{ $t("电话") }}:17372137306</span>
        </div>
      </div>
    </div>

    <div><Footer style="margin: 0" /></div>
  </div>
</template>

<script setup>
import Footer from "../Footer";
import { reactive, ref } from "vue";

const activeName = ref("1");
let indexed = ref("0");
const clickBtm = (num) => {
  indexed.value = num;
};

const handleClick = (tab, event) => {
  console.log(tab, event);
};

const data = [
  {
    desc: "经纪业务:为金融持牌机构、公司提供经纪业务，促成不同业务领域的合作与",
    name: "期权课程",
    img: require("@/assets/chaojiao/主营业务/3.png"),
  },
  {
    desc: "培训业务:我们提供有偿股票/期货/期权培训服务，与金融老师合作，提升你",
    name: "股票课程",
    img: require("@/assets/chaojiao/主营业务/2.png"),
  },
  {
    desc: "期货课程期货交易是一种利用价格波动来获取收盒的金融活动，它涉及到各",
    name: "期货课程",
    img: require("@/assets/chaojiao/主营业务/1.png"),
  },
  {
    desc: "如果你励志在金融投教行业发展、如果你的图队/公司没有好的项目、如果你",
    name: "线下俱乐部",
    img: require("@/assets/chaojiao/主营业务/4.png"),
  },
  {
    desc: "《超级交易员论坛,走私募》作为普通投资者和私募公司之间的桥梁，勇于做",
    name: "走访私募",
    img: require("@/assets/chaojiao/主营业务/5.png"),
  },
  {
    desc: "如何联系我们",
    name: "开戶业务",
    img: require("@/assets/chaojiao/主营业务/6.png"),
  },
];
</script>

<style scoped>
.text-center {
  overflow-y: hidden;
}

.carousel-item {
  color: #475669;
  opacity: 0.75;
  margin: 0;
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  display: flex;
  align-items: center;
  margin: 0;
  text-align: center;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.container {
  width: 1200px;
  margin: 80px auto 0;
  color: #fff;

  div {
    width: 100%;
  }
  h1 {
    font-size: 40px;
    line-height: 0px;
  }
  span {
    font-size: 16px;
  }
  .line {
    width: 80%;
    height: 1px;
    background: #8d0100;
    margin: 10px auto 30px;
  }
}

/deep/.el-table th.el-table__cell {
  background-color: var(--el-table-header-bg-color);
  background: #910101;
  border-bottom: none;
}
/deep/.el-table tr {
  background-color: var(--el-table-tr-bg-color);
  background: black;
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: var(--el-fill-color-lighter);
  background: #1c1c1c;
}
/deep/.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: none;
}

.el-link {
  --el-link-font-size: var(--el-font-size-base);
  --el-link-font-weight: var(--el-font-weight-primary);
  /* --el-link-text-color: var(--el-text-color-regular); */
  /* --el-link-hover-text-color: var(--el-color-primary); */
  /* --el-link-disabled-text-color: var(--el-text-color-placeholder); */
  align-items: center;
  color: var(--el-link-text-color);
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  font-size: var(--el-link-font-size);
  font-weight: var(--el-link-font-weight);
  justify-content: center;
  outline: none;
  padding: 0;
  position: relative;
  text-decoration: none;
  vertical-align: middle;
}
.business {
  background: #fff;
  height: 350px;
  width: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 20px;
  box-sizing: border-box;
  justify-content: space-between;
}
.business-col {
  /* background: rgba(25, 21, 142, 37); */
  /* background: #3f3bc5; */
  color: #fff;
  background-image: url("@/assets/chaojiao/期权.png");
  background-size: cover; /* 或者使用 100% 100% */
  background-position: center; /* 确保图片居中 */
  background-repeat: no-repeat; /* 防止图片重复 */
}

/deep/.el-carousel__item[data-v-2c4fa7e1]:nth-child(2n + 1) {
  background-color: rgba(0, 0, 0, 0);
}
</style>
